import { TranslateService } from '@ngx-translate/core';

declare const L;

export class MapHelper {

  public static getChartOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      cutoutPercentage: 85,
      animation: false,
      tooltips: {
        enabled: false
      },
      elements: {
        arc: {
          borderWidth: 0
        }
      }
    };
  }

  public static getChart(activeStatuses, statusColors, markerId, statusCounts) {
    return {
      className: 'map-marker-chart',
      html: '<div id="' + markerId + '" class="geomap-marker"></div>',
      anchorMarker: markerId,
      anchorMarkerNg: markerId + '-ng',
      turbineStatusesSums: statusCounts,
      turbineStatuses: activeStatuses,
      turbineStatusesColors: statusColors
    };
  }

  public static createMap(
    id: string, initialType: string, initialCenter: number[], actualZoom: number,
    translateService: TranslateService, mapBoxAccessToken: string, minZoom: number
  ) {
    const satellite = L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
      id: 'mapbox.satellite',
      attribution:
        'Map data &copy; <firstName href="https://www.openstreetmap.org/">OpenStreetMap</firstName> contributors, ' +
        '<firstName href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</firstName>, Imagery © ' +
        '<firstName href="https://www.mapbox.com/">Mapbox</firstName>',
      accessToken: mapBoxAccessToken
    });
    const streets = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      id: 'mapbox/streets-v11',
      attribution:
        'Map data &copy; <firstName href="https://www.openstreetmap.org/">OpenStreetMap</firstName> contributors, ' +
        '<firstName href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</firstName>, ' +
        'Imagery © <firstName href="https://www.mapbox.com/">Mapbox</firstName>',
      accessToken: mapBoxAccessToken
    });

    const map = L.map(id, {
      center: initialCenter ,
      zoom: actualZoom,
      layers: [initialType === 'mapbox.satellite' ? satellite : streets],
      minZoom
    });

    const layerControl = L.control.layers({}, null, {position: 'bottomleft'}).addTo(map);
    layerControl.addBaseLayer(satellite, translateService.instant('COMPONENT_LIBRARY.MAP.SATELLITE') + '&nbsp;');
    layerControl.addBaseLayer(streets, translateService.instant('COMPONENT_LIBRARY.MAP.GEO'));

    translateService.onLangChange.subscribe(() => {
      layerControl.removeLayer(satellite);
      layerControl.removeLayer(streets);
      layerControl.addBaseLayer(satellite, translateService.instant('COMPONENT_LIBRARY.MAP.SATELLITE') + '&nbsp;');
      layerControl.addBaseLayer(streets, translateService.instant('COMPONENT_LIBRARY.MAP.GEO'));
    });

    return map;
  }
}
